import { map, observe, switchLatest } from 'most';
import { sync } from 'most-subject';
import { epicBegin, epicEnd } from './actions';
import { STATE_STREAM_SYMBOL } from './constants';

export var createEpicMiddleware = function createEpicMiddleware(epic) {
  if (typeof epic !== 'function') {
    throw new TypeError('You must provide an Epic (a function) to createEpicMiddleware.');
  }

  var actionsIn$ = sync();

  var epic$ = sync();

  var middlewareApi = void 0;

  var epicMiddleware = function epicMiddleware(_middlewareApi) {
    middlewareApi = _middlewareApi;

    return function (next) {
      var callNextEpic = function callNextEpic(nextEpic) {
        middlewareApi.dispatch(epicBegin());

        var state$ = middlewareApi[STATE_STREAM_SYMBOL];
        var isUsingStateStreamEnhancer = !!state$;

        return isUsingStateStreamEnhancer ? nextEpic(actionsIn$, state$) : nextEpic(actionsIn$, middlewareApi);
      };

      var actionsOut$ = switchLatest(map(callNextEpic, epic$));
      observe(middlewareApi.dispatch, actionsOut$);

      epic$.next(epic);

      return function (action) {
        var result = next(action);
        actionsIn$.next(action);
        return result;
      };
    };
  };

  epicMiddleware.replaceEpic = function (nextEpic) {
    middlewareApi.dispatch(epicEnd());
    epic$.next(nextEpic);
  };

  return epicMiddleware;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-most/es/createEpicMiddleware.js
// module id = 856
// module chunks = 0